/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ShopZerocost,
  ShopZerocostInterface,
  ShopConstructor,
} from "../ShopZerocost";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "discounts",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "discountsReceiverWallet",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct ShopConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "zerocost",
        type: "address",
      },
      {
        internalType: "address",
        name: "discounts",
        type: "address",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "discountsReceiverWallet",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "discounts",
            type: "address",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "discountsReceiverWallet",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
        ],
        internalType: "struct ShopConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "requester",
        type: "address",
      },
    ],
    name: "viewDiscount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ShopZerocostConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ShopZerocostConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ShopZerocost__factory extends ContractFactory {
  constructor(...args: ShopZerocostConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ShopZerocost";
  }

  deploy(
    input: ShopConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ShopZerocost> {
    return super.deploy(input, overrides || {}) as Promise<ShopZerocost>;
  }
  getDeployTransaction(
    input: ShopConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): ShopZerocost {
    return super.attach(address) as ShopZerocost;
  }
  connect(signer: Signer): ShopZerocost__factory {
    return super.connect(signer) as ShopZerocost__factory;
  }
  static readonly contractName: "ShopZerocost";
  public readonly contractName: "ShopZerocost";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ShopZerocostInterface {
    return new utils.Interface(_abi) as ShopZerocostInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ShopZerocost {
    return new Contract(address, _abi, signerOrProvider) as ShopZerocost;
  }
}
